export default function ListIllustration({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="56"
      height="56"
      viewBox="0 0 90 96"
    >
      <path
        fillRule="evenodd"
        d="M28.3 12a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v8a8 8 0 0 1-8 8h-24a8 8 0 0 1-8-8v-8Zm32 0h-24v8h24v-8Z"
        clipRule="evenodd"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        d="M24.3 20a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4h-8a4 4 0 1 1 0-8h8a12 12 0 0 1 12 12v56a12 12 0 0 1-12 12h-48a12 12 0 0 1-12-12V24a12 12 0 0 1 12-12h8a4 4 0 0 1 0 8h-8Z"
        clipRule="evenodd"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        d="M44.3 44a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4Zm0 20a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4Zm-16-20a4 4 0 1 1 4 4 4 4 0 0 1-4-4Zm0 20a4 4 0 1 1 4 4 4 4 0 0 1-4-4Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    </svg>
  )
}
